import PageLoader from '../../component/loader/PageLoader';

export const getOrderColumnDefinition = (loadingDelivery, deliveryDetails) => [
  {
    id: 'orderNumber',
    accessorKey: 'orderNumber',
    size: 100,
    minSize: 100,
    header: 'Order #',
    filterFn: 'tableFilterFn'
  },
  {
    id: 'orderDate',
    accessorKey: 'orderDate',
    size: 100,
    minSize: 100,
    header: 'Order Date',
    filterFn: 'tableFilterFn'
  },
  {
    id: 'paid',
    accessorKey: 'paid',
    header: 'Payment Status',
    size: 80,
    minSize: 80,
    cell: (info) => (info.getValue() ? 'Paid' : 'Unpaid')
  },
  {
    id: 'delivery',
    accessorKey: 'delivery',
    header: 'Delivery Cost',
    size: 100,
    minSize: 100,
    cell: (info) => `R ${Number(info.getValue()).toFixed(2)}`
  },
  {
    id: 'amount',
    accessorKey: 'amount',
    header: 'Total Cost',
    size: 100,
    minSize: 100,
    cell: (info) => `R ${Number(info.getValue()).toFixed(2)}`
  },
  {
    accessorKey: 'deliveryDate',
    header: 'Delivery Date',
    cell: (info) => {
      const orderNumber = info.row.original.orderNumber;
      if (loadingDelivery?.[orderNumber]) return <PageLoader />;
      return deliveryDetails?.[orderNumber]?.deliveryDate;
    }
  },
  {
    accessorKey: 'trackingLink',
    header: 'Track Order',
    cell: (info) => {
      const orderNumber = info.row.original.orderNumber;
      if (loadingDelivery?.[orderNumber]) return <PageLoader />;
      const status = deliveryDetails?.[orderNumber]?.status ?? '';
      const link = deliveryDetails?.[orderNumber]?.trackingLink ?? '';
      return status === 'OUT FOR DELIVERY' ? (
        <a href={link} target="_blank" rel="noopener noreferrer">
          <span className="orders__tracking-link">{link ? 'TRACK ORDER' : ''}</span>
        </a>
      ) : (
        ''
      );
    }
  },
  {
    accessorKey: 'status',
    header: 'Order Status',
    cell: (info) => {
      const orderNumber = info.row.original.orderNumber;
      if (loadingDelivery?.[orderNumber]) return <PageLoader />;
      const status = deliveryDetails?.[orderNumber]?.status ?? '';
      return (
        <span
          className={`orders__status orders__status--${status.toLowerCase().replace(/\s+/g, '-')}`}
        >
          {status}
        </span>
      );
    }
  }
];
